import { graphql, Link as GatsbyLink } from "gatsby";
import React from "react";
import { Box, Heading, Link } from "theme-ui";
import SEO from "react-seo-component";
import { CountDown } from "../components/countDown";

//Actual entry point
export default function exercises({ data }) {
  
  return (
    <>
       {/* <CountDown/> */}

      <p>This is where I'll be keeping the coding puzzles and interview questions I come across.</p>
      <p>I usually solve the puzzles in a variety of languages and with different approaches.</p>
      <h6>Also this is not *all* of the coding challenges I've done just the ones that I managed to turn into a post so far</h6>
      {data.allMdx.nodes.map(({ id, excerpt, frontmatter, slug }) => (
        <Box
          key={id}
          as="article"
          sx={{
            mb: 4,
            p: 3,
            boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
            border: "1px solid #d1d1d1",
            borderRadius: "15px",
          }}
        >
          <Link as={GatsbyLink} to={`/${slug}`}
            sx={{
              textDecoration: `none`,
              ":hover": {
                textDecoration: `underline`,
              },
            }}>
            <Heading>{frontmatter.title}</Heading>
            <Box as="p" variant="styles.p">
              {frontmatter.date}
            </Box>
            <Box as="p" variant="styles.p">
              {excerpt}
            </Box>
          </Link>
        </Box>
      ))}
    </>
  );
}

export const query = graphql`
  query SITE_INDEX_QUERY_PUZZLE {
    allMdx(
      filter: {frontmatter: {type: {eq: "puzzle"}}}
      sort: { fields: [frontmatter___date], order: DESC }) {
      nodes {
        id
        excerpt(pruneLength: 50)
        frontmatter {
          title
          date(formatString: "YYYY MMMM Do")
          scrollerComponent
        }
        slug
      }
    }
  }
`;
